exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-cart{min-height:100%}.order-cart .order-pro-total{margin-top:auto}.ordercart{position:fixed;top:0;right:0;max-width:560px;width:100%;height:100%;display:flex;flex-direction:column;border-left:20px solid rgba(234,205,212,.15)}@media (max-width:767px){.ordercart{position:static;border-left:0!important}}", ""]);

// exports
